import {FC, useState} from 'react'
import clsx from 'clsx'
import {useAppDispatch, useAppSelector} from '../../../../hooks/redux'
import {updateQuery} from '../../slices/cdrFilterSlice'
import {shallowEqual} from 'react-redux'
import {ClientInfo} from '../../core/_models'
import {useParams} from 'react-router-dom'
import {KTSVG} from '../../../../template/helpers'
import {appsAPI} from '../../../../services/AppsService'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'

type Props = {
  data: string
  clientInfo?: ClientInfo
}

const CDRClient: FC<Props> = ({data, clientInfo}) => {
  const dispatch = useAppDispatch()
  const [hover, setHover] = useState(false)
  const {appId} = useParams()
  const query = useAppSelector((state) => state.cdrFilter.query, shallowEqual)
  const {data: app} = appsAPI.useFetchAppByIdQuery(appId!)
  // client names from CRM are shown only with personal data and client names in CDR enabled (docs/PERSONAL_DATA.md)
  const showClient = clientInfo != null && app?.personal_data === true && app?.cdr_client_names === true

  const handleUpdateState = () => {
    if (query?.rules === undefined) {
      dispatch(updateQuery({search: data}))
    }
  }

  return (
    <div className='d-flex align-items-center'>
      <div
        className={clsx('d-flex justify-content-start flex-column me-3 text-gray-800', {
          'cursor-pointer': query?.rules === undefined,
        })}
        onClick={handleUpdateState}
      >
        <span
          className={clsx('mt-1', {'text-gray-600': hover})}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          {showClient ? (
            <>
              <OverlayTrigger
                delay={{show: 50, hide: 50}}
                overlay={
                  <Tooltip id='tooltip-title' style={{position: 'fixed'}}>
                    {data}
                  </Tooltip>
                }
              >
                <span>{clientInfo?.name}</span>
              </OverlayTrigger>
              <div className='fs-7 text-gray-700'>{clientInfo?.company?.title}</div>
            </>
          ) : (
            <span className='small'>{data}</span>
          )}
        </span>
      </div>
      {showClient && (
        <a
          href={`https://${app?.crm_domain}/crm/${clientInfo?.type.toLowerCase()}/details/${clientInfo?.id}/`}
          className='ms-2'
          target='_blank'
          rel='noreferrer'
        >
          <KTSVG
            path='/media/icons/duotune/arrows/arr095.svg'
            className='svg-icon svg-icon-gray-900 text-hover-primary'
          />
        </a>
      )}
    </div>
  )
}

export {CDRClient}
